import { CACHE_TTL } from '@ps/utils';

/**
 * TTL for per-parent child survey rows (see `docs/caching.md`).
 * Child lists can change more often than the main list; keep this short.
 */
export const SURVEY_CHILD_SURVEYS_CACHE_TTL = CACHE_TTL.SHORT;

export const REFERENCE_CACHE_TTL_MS = CACHE_TTL.DEFAULT;

export const SURVEY_TRANSACTION_STATUSES_CACHE_TTL_MS = CACHE_TTL.SESSION;
